export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9200.6ece2a0f.jpg";